import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';

import { ActionCableContext } from '@/context/ActionCableContext';

import styles from './styles/inbox.module.css';
import { Thread } from './Thread';
import { ThreadList } from './ThreadList';
import { ThreadInput } from './ThreadInput';
import { ThreadPlaceholder } from './ThreadPlaceholder';

export function Inbox() {
  const {
    inboxCount,
    secureMessageThreads: threads,
    error,
    isLoading,
  } = useContext(ActionCableContext);

  const threadRef = useRef<HTMLDivElement>(null);

  const [replyMode, setReplyMode] = useState(false);
  const [selectedThreadId, setSelectedThreadId] = useState<null | number>(null);
  const [sidebarOverlaps, setSidebarOverlaps] = useState(true);

  const orderedThreads = _.orderBy(
    threads,
    ['unreadMessage', 'resolved', 'lastMessageSentAt'],
    ['desc', 'asc', 'desc']
  );
  const thread = _.find(threads, ['id', selectedThreadId]);

  useEffect(() => {
    if (!thread) {
      setSidebarOverlaps(true);
    }
  }, [thread]);

  const handleThreadClick = (id: number | null) => {
    if (id === null) {
      setSelectedThreadId(null);
      return;
    }

    setSelectedThreadId(id);
    setSidebarOverlaps(false);
    setReplyMode(false);
    threadRef.current?.focus();
  };

  return (
    <div className="-mx-4">
      <div className={styles.withSidebar}>
        <div className={sidebarOverlaps ? '' : 'hidden md:block'}>
          <aside className={styles.sidebar} role="navigation" tabIndex={0}>
            <ThreadList
              selectedThread={thread}
              threads={orderedThreads}
              handleThreadClick={handleThreadClick}
            />
          </aside>
        </div>
        {!_.isEmpty(thread) && (
          <main className={styles.mainViewport}>
            <Thread
              id={selectedThreadId}
              replyMode={replyMode}
              threadRef={threadRef}
            />
            <ThreadInput
              setReplyMode={setReplyMode}
              setSidebarOverlaps={setSidebarOverlaps}
              replyMode={replyMode}
              thread={thread || undefined}
            />
          </main>
        )}
        {_.isEmpty(thread) && (
          <main className="flex flex-col items-center justify-center">
            <ThreadPlaceholder
              count={inboxCount}
              error={error}
              isLoading={isLoading}
            />
          </main>
        )}
      </div>
    </div>
  );
}
